import { render, staticRenderFns } from "./HostedVlanService.vue?vue&type=template&id=dd59515c&"
import script from "./HostedVlanService.vue?vue&type=script&lang=js&"
export * from "./HostedVlanService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports